import React from 'react';
import LocationTemplate from './LocationTemplate';

const EurekaPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Eureka"
      stateName="North Carolina"
      countyName="Wayne"
      zipCodes={["28337"]}
      latitude={35.5357}
      longitude={-77.8806}
      population={197}
      historicalFact="Established in the late 19th century, named after the Greek expression meaning 'I have found it.'"
      nearbyTowns={[
        "Goldsboro, NC",
        "Seven Springs, NC",
        "Mount Olive, NC",
        "Fremont, NC",
        "Pikeville, NC",
        "La Grange, NC",
        "Kinston, NC",
        "Wilson, NC"
      ]}
    />
  );
};

export default EurekaPage;